import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBNGvGob1xRGf86twcBxEaGRMxvZH8sOT0",
  authDomain: "neuro-painel.firebaseapp.com",
  databaseURL: "https://neuro-painel-default-rtdb.firebaseio.com",
  projectId: "neuro-painel",
  storageBucket: "neuro-painel.appspot.com",
  messagingSenderId: "790923095549",
  appId: "1:790923095549:web:6aff1a9ff9c9ff2f31bd94"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firestore instance
export const db = getFirestore(app);

// Get Auth instance
export const auth = getAuth(app);

// Get Storage instance
export const storage = getStorage(app);

// Enhanced authentication function with retry logic
export async function authenticateFirebase(email: string, password: string, retryAttempts = 3) {
  let lastError;
  
  for (let attempt = 0; attempt < retryAttempts; attempt++) {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error) {
      lastError = error;
      if (error.code !== 'auth/network-request-failed') {
        break; // Don't retry on non-network errors
      }
      await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1))); // Exponential backoff
    }
  }
  
  console.error('Firebase authentication failed:', lastError);
  throw lastError;
}

// Enhanced auth state observer
export function observeAuthState(callback: (user: any) => void) {
  return onAuthStateChanged(auth, (user) => {
    try {
      callback(user);
    } catch (error) {
      console.error('Auth state observer error:', error);
    }
  });
}